import React from 'react'
import { Pagination } from 'react-admin'

const DefaultPagination = (props: any) => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export default DefaultPagination;